import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { text } from '../text';
import { CourseType } from '../types';



type Feature = {
  feature_id: number;
  feature_name: string;
  icon: string;
};

type Property = {
  property_id: string;
  property_name: string;
  address: string;
  locality_id: string;
  locality_name: string | null;
  city_id: string;
  city_name: string;
  pincode: string;
  state: string;
  features: Feature[] | null;
  // photos: any; // Replace `any` if photo type is known
  photos: string[] | null;
  minimum_rent: number;
  shortName: string;
};




type Props = {
  course: Property;
  shortName?: boolean;
  numberOfLines?: number;
  style?: React.CSSProperties;
};

export const CourseName: React.FC<Props> = ({
  course,
  style,
  shortName,
  numberOfLines,
}) => {
  return (
    <text.H6
      style={style}
      numberOfLines={numberOfLines}
    >
      {shortName ? course.shortName : course.property_name}
    </text.H6>
  );
};
